import extractParams from './extractParams';
import makeQueryString from './makeQueryString';
import splitUrl from './splitUrl';

const adjustUrlParams = (adjust, url) => {
  const parts = splitUrl(url);
  const newParams = adjust(extractParams(url)) || {};
  const newUrl = `${parts.baseHref}?${makeQueryString(newParams)}`;
  // Strip trailing `?` if there are no params
  return newUrl.replace(/\?$/, '');
};

export default adjustUrlParams;
